import React from 'react';
import { createRoot, Root } from 'react-dom/client';

import storeUserForm from './store/user-account';

import App from './app';

let entryPoint: HTMLElement;
let root: Root;

const initApp = (): void => {
  if (entryPoint.dataset.userForm) {
    storeUserForm.setFields(JSON.parse(entryPoint.dataset.userForm));
  }

  root = createRoot(entryPoint);
  root.render(
    React.createElement(App),
  );
};

const init = (): void => {
  entryPoint = document.querySelector('#denso-account');

  if (entryPoint) {
    initApp();
  }
};

export default {
  init,
};
